import React, { Component } from "react";
import "../styles/SplashScreen.css";

function SplashMessage() {
  return (
    <div className="splash-container">
      <h1 className="splash-text">
        Loo<span className="highlight-k">K</span>it
      </h1>
      <div className="splash-subtext"> Look. Learn. Live. Love. </div>
    </div>
  );
}

export default function withSplashScreen(WrappedComponent) {
  return class extends Component {
    constructor(props) {
      super(props);

      const alreadyShown = sessionStorage.getItem("splashShown");

      this.state = {
        loading: !alreadyShown, // show splash only if not shown before
        fadeOut: false,
      };
    }

    componentDidMount() {
      if (this.state.loading) {
        setTimeout(() => {
          this.setState({ fadeOut: true });

          setTimeout(() => {
            this.setState({ loading: false });
            sessionStorage.setItem("splashShown", "true"); // mark splash as shown
          }, 1000); // wait for slide
        }, 2000); // splash display duration
      }
    }

    render() {
      if (this.state.loading) {
        return (
          <div
            className={`splash-wrapper ${this.state.fadeOut ? "slide-up" : ""}`}
          >
            <SplashMessage />
          </div>
        );
      }
      return <WrappedComponent {...this.props} />;
    }
  };
}
